import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Documents from './pages/Documents';

import News from './pages/News';
import Contact from './pages/Contact';
import HRPolicy from './pages/corporate/HRPolicy';
import PrivacyPolicy from './pages/corporate/PrivacyPolicy';
import TermsConditions from './pages/corporate/TermsConditions';
import FAQ from './pages/corporate/FAQ';
import VisionMission from './pages/corporate/VisionMission';
import QualityPolicy from './pages/corporate/QualityPolicy';
import CoreValues from './pages/corporate/CoreValues';
import TechnicalSupport from './pages/services/TechnicalSupport';
import QualityControl from './pages/services/QualityControl';
import Logistics from './pages/services/Logistics';
import Consulting from './pages/services/Consulting';
import TechnicalDocumentation from './pages/services/TechnicalDocumentation';
import Factories from './pages/Factories';
import Plants from './pages/Plants';
import Subsidiaries from './pages/Subsidiaries';
import UrfaFactory from './pages/factories/UrfaFactory';
import HalepFactory from './pages/factories/HalepFactory';
import MardinFactory from './pages/factories/MardinFactory';
import NigdeFactory from './pages/factories/NigdeFactory';
import UrfaBeton from './pages/factories/UrfaBeton';
import HatayBeton from './pages/factories/HatayBeton';
import KilisBeton from './pages/factories/KilisBeton';
import RakkaBeton from './pages/factories/RakkaBeton';
import RakkaAlci from './pages/factories/RakkaAlci';
import UrfaKalker from './pages/factories/UrfaKalker';
import Lojistik from './pages/factories/Lojistik';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
    line-height: 1.6;
    color: #1a1a1a; /* slightly darker for better contrast */
    background-color: #ffffff;
    font-size: 16px;
    font-weight: 400; /* Normal weight instead of 300 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600; /* Semi-bold instead of 300 */
    line-height: 1.25;
    letter-spacing: -0.5px;
    color: #111827; /* Darker heading color */
    
    @media (max-width: 768px) {
      line-height: 1.3;
      letter-spacing: -0.25px;
    }
  }

  p {
    line-height: 1.7;
    font-weight: 400; /* Normal weight instead of 300 */
    color: #374151; /* Stronger body text color */
    
    @media (max-width: 768px) {
      font-size: 15px; /* Slightly smaller for mobile reading */
      line-height: 1.6;
    }
  }

  /* Ultra Clean Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  padding-top: 80px; /* Header height */
`;

function App() {
  return (
    <LanguageProvider>
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <AppContainer>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/belgeler" element={<Documents />} />

            <Route path="/haberler" element={<News />} />
            <Route path="/iletisim" element={<Contact />} />
            
            {/* Kurumsal Alt Sayfalar */}
            <Route path="/hakkimizda/insan-kaynaklari" element={<HRPolicy />} />
            <Route path="/hakkimizda/gizlilik" element={<PrivacyPolicy />} />
            <Route path="/hakkimizda/sartlar" element={<TermsConditions />} />
            <Route path="/hakkimizda/sss" element={<FAQ />} />
            <Route path="/hakkimizda/vizyon" element={<VisionMission />} />
            <Route path="/hakkimizda/kalite" element={<QualityPolicy />} />
            <Route path="/hakkimizda/degerler" element={<CoreValues />} />
            
            {/* Fabrikalar */}
            <Route path="/fabrikalar" element={<Factories />} />
            <Route path="/fabrikalar/urfa" element={<UrfaFactory />} />
            <Route path="/fabrikalar/halep" element={<HalepFactory />} />
            <Route path="/fabrikalar/mardin" element={<MardinFactory />} />
            <Route path="/fabrikalar/nigde" element={<NigdeFactory />} />
            
            {/* Santraller */}
            <Route path="/santraller" element={<Plants />} />
            <Route path="/santraller/urfa-beton" element={<UrfaBeton />} />
            <Route path="/santraller/hatay-beton" element={<HatayBeton />} />
            <Route path="/santraller/kilis-beton" element={<KilisBeton />} />
            <Route path="/santraller/rakka-beton" element={<RakkaBeton />} />
            
            {/* İştirakler */}
            <Route path="/istirakler" element={<Subsidiaries />} />
            <Route path="/istirakler/rakka-alci" element={<RakkaAlci />} />
            <Route path="/istirakler/urfa-kalker" element={<UrfaKalker />} />
            <Route path="/istirakler/lojistik" element={<Lojistik />} />
            
            {/* Hizmetler Alt Sayfalar */}
            <Route path="/hizmetler/teknik-destek" element={<TechnicalSupport />} />
            <Route path="/hizmetler/kalite-kontrol" element={<QualityControl />} />
            <Route path="/hizmetler/lojistik" element={<Logistics />} />
            <Route path="/hizmetler/danismanlik" element={<Consulting />} />
            <Route path="/hizmetler/teknik-dokumantasyon" element={<TechnicalDocumentation />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
    </LanguageProvider>
  );
}

export default App;